import { Component } from '@angular/core';
import { PortalTypeEnum } from '@ats/api/cm';
import { CmSettingsService } from '@ats/cm/core';

@Component({
    selector: 'cm-timeout-modal',
    templateUrl: './cm-timeout-modal.component.html',
    styleUrls: ['./cm-timeout-modal.component.scss'],
    standalone: false
})
export class CmTimeoutModalComponent {
	readonly locFeature: string;
	constructor(private settings: CmSettingsService) {
		this.locFeature = this.settings.portal === PortalTypeEnum.CandidatePortal ? 'CandidateAccess.Login' : 'Core';
	}
}
